import React, { useEffect } from "react";
import { helmetJsonLdProp } from "react-schemaorg";
import { Helmet } from "react-helmet";

export default function CourseSchemaTag(props) {
  const [course_type, setCourseType] = React.useState("");
  const [courseVideoLink, setCourseVideoLink] = React.useState();
  const [courseVideoThumbnail, setCourseVideoThumbnail] = React.useState();
  const [start_date, setStart_date] = React.useState();
  const [end_date, setEnd_date] = React.useState();
  const [ratingValue, setRatingValue] = React.useState();
  const [instructors, setInstructors] = React.useState();
  const [offerPrice, setOfferPrice] = React.useState();
  const [offerAvailable, setOfferAvailable] = React.useState();
  const [primaryKeywords, setPrimaryKeywords] = React.useState();
  const [secondaryKeywords, setSecondaryKeywords] = React.useState();

  useEffect(() => {
    setRatingValue(
      props.data.right_section
        ? props.data.right_section.ratings.average_rating
        : 4.8
    );
  }, []);

  useEffect(() => {
    var inst = [];
    if (props.data.mentors) {
      for (let i = 0; i < props.data.mentors.length; i++) {
        inst.push({
          "@type": "Person",
          name: props.data.mentors[i].mentor,
          image: props.data.mentors[i].profile_image,
          jobTitle: props.data.mentors[i].mentor_bio,
        });
      }
      setInstructors(inst);
    }

    if (props.data.intro_video_link) {
      setCourseVideoLink(props.data.intro_video_link.link);
      setCourseVideoThumbnail(props.data.intro_video_link.thumbnail_image);
      setCourseType(
        props.data.course_type == 2
          ? "Live Course"
          : props.data.course_type == 1
          ? "Online Course"
          : "Offline Course"
      );
    }
  }, [props.data.mentors, props.data.intro_video_link]);

  useEffect(() => {
    if (props.data.intro_video_link) {
      setCourseVideoLink(props.data.intro_video_link.link);
      setCourseVideoThumbnail(props.data.intro_video_link.thumbnail_image);
      setCourseType(
        props.data.course_type == 2
          ? "Live Course"
          : props.data.course_type == 1
          ? "Online Course"
          : "Offline Course"
      );
    }
  }, [props.data.intro_video_link]);

  useEffect(() => {
    setStart_date(
      props.data.first_upcoming_batch
        ? props.data.first_upcoming_batch.reg_start_date
        : null
    );
    setEnd_date(
      props.data.first_upcoming_batch
        ? props.data.first_upcoming_batch.reg_end_date
        : null
    );
    setOfferPrice(
      props.data.first_upcoming_batch
        ? props.data.first_upcoming_batch.promotional_fee
        : null
    );

    if (props.data.first_upcoming_batch) {
      setOfferAvailable(
        props?.data?.first_upcoming_batch?.online_course_meta?.registration_open
      );
    }
  }, [props.data.first_upcoming_batch]);

  useEffect(() => {
    if (props.data.keywords) {
      if (props.data.keywords.primary_keywords) {
        setPrimaryKeywords(props.data.keywords.primary_keywords);
        setSecondaryKeywords(props.data.keywords.secondary_keywords);
      }
      else {
        setPrimaryKeywords(props.data.course_name);
        setSecondaryKeywords(props.data.course_name);
      }      
    } else {
      setPrimaryKeywords(props.data.course_name);
      setSecondaryKeywords(props.data.course_name);
    }
    
  }, [props.data.keywords]);


  return (
    <Helmet
      script={[
        helmetJsonLdProp({
          "@context": "http://schema.org", // required
          "@graph": [
            // breadcrumb graph for crawlers
            {
              "@type": "BreadcrumbList",
              name: "breadcrumblist",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  item: {
                    name: "Course",
                    "@id": "https://practice.geeksforgeeks.org/courses",
                  },
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  item: {
                    name: course_type,
                    "@id":
                      "https://practice.geeksforgeeks.org/courses/" +
                      course_type.split(" ")[0].toLowerCase(),
                  },
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  item: {
                    name: props.data.course_name,
                    "@id":
                      "https://practice.geeksforgeeks.org/courses/" +
                      course_type.split(" ")[0].toLowerCase() +
                      "/#" +
                      props.data.course_slug,
                    // @id refers to the anchor on the course/online page that is clicked
                  },
                },
              ],
            },
            {
              "@type": "Course",
              "@id":
                "https://practice.geeksforgeeks.org/courses/" +
                props.data.course_slug,
              name: props.data.course_name,
              description: props.data.short_description,
              url:
                "https://practice.geeksforgeeks.org/courses/" +
                props.data.course_slug,
              About: {
                "@type": "Thing",
                name: primaryKeywords? primaryKeywords.concat(secondaryKeywords) : props.data.course_name,
                subjectOf: props.data.course_name,
              },
              provider: {
                "@type": "Organization",
                name: "GeeksforGeeks",
                url: "https://practice.geeksforgeeks.org",
                sameAs: [
                  "https://www.facebook.com/geeksforgeeks.org/",
                  "https://in.linkedin.com/company/geeksforgeeks",
                  "https://twitter.com/geeksforgeeks",
                  "https://www.instagram.com/geeks_for_geeks/",
                  "https://www.youtube.com/geeksforgeeksvideos",
                ],
              },
              image: courseVideoThumbnail,
              educationalCredentialAwarded: "Course Certificate",
              inLanguage: "en",
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: ratingValue,
                ratingCount: props.data.users_rated_to_course_count,
              },
              video: courseVideoLink
                ? {
                    "@type": "VideoObject",
                    name: props.data.course_name,
                    description: props.data.short_description,
                    thumbnailUrl: courseVideoThumbnail,
                    uploadDate: "2021-12-01T00:00:00+00:00", // Default date : 1st December 2021.
                    contentUrl: courseVideoLink,
                    playerType: "HTML5 Flash",
                  }
                : null,
              hasCourseInstance: [
                {
                  "@type": "CourseInstance",
                  name: props.data.course_name,
                  description: props.data.short_description,
                  image: courseVideoThumbnail,
                  courseMode: ["online"],
                  startDate: start_date,
                  endDate: end_date,
                  offers: {
                    "@type": "Offer",
                    price: offerPrice,
                    priceCurrency: "INR",
                    availability: offerAvailable
                      ? "http://schema.org/InStock"
                      : "http://schema.org/OutOfStock",
                    url:
                      "https://practice.geeksforgeeks.org/courses/" +
                      props.data.course_slug +
                      "/#register",
                    availability: "OnlineOnly",
                  },
                  instructor: instructors,
                },
              ],
            },
          ],
        }),
      ]}
    />
  );
}
